// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1733154160502
      var cssReload = require("C:/DiscoE/3x1010/Projects-CdC/contest.compagniadeicaraibi.com/VisualStudio/Web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  